<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text mb-2">
        {{ t('Запись на приём', options) }}
      </div>
    </slot>
    <v-radio-group
      :value="t(doctorFiltersState.visitLocation, options)"
      class="mt-0 pt-0"
      hide-details
      column
      mandatory
      @change="handleChange"
    >
      <v-radio
        v-for="(item, i) in items"
        :key="i"
        :value="item.value"
        :data-qa-value="item.value"
        class="my-3"
        data-qa="filter-visit-location-type"
      >
        <template #label>
          <div
            class="text-body-1 text--text"
          >
            {{ t(item.name, options) }}
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRefs } from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()

const items = ref<{ name: string, value: Filters['visitLocation'] }[]>([
  { name: 'В клинике', value: 'clinic' },
  { name: 'На дому', value: 'home' },
  { name: 'Онлайн', value: 'online' },
])

const handleChange = (visitLocation: Filters['visitLocation']) => {
  const hasUnsavedVisitLocation = filtersStore.filters.visitLocation !== visitLocation
  const disease = hasUnsavedVisitLocation ? undefined : filtersStore.filters.disease
  const otherSpeciality = hasUnsavedVisitLocation ? undefined : filtersStore.filters.otherSpeciality
  const sort = hasUnsavedVisitLocation && visitLocation === 'online' && filtersStore.filters.sort === 'rating' ? undefined : filtersStore.filters.sort

  filtersStore.updateUnsavedFilters({
    sort,
    disease,
    visitLocation,
    otherSpeciality,
  })
  emit('input', {
    ...doctorFiltersState.value,
    sort,
    disease,
    visitLocation,
    otherSpeciality,
  })
}
</script>
